import axios from '../axios'

export const login = data => {
    return axios({
        url: '/v1/session',
        method: 'post',
        data
    })
};